import {
  Grid,
  FormControl,
  Input,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import React from 'react';

import CloseBtn from '../../../components/CloseBtn';
import Logo from '../components/Logo';
import { API_ROOT } from '../../../../../../../../../../api/Routes';
import { AccountCircle } from '@material-ui/icons';

const regions = [
  {
    name: 'UK',
    id: 'UK',
  },
  {
    name: 'Europe',
    id: 'EUROPE',
  },
  {
    name: 'Middle East',
    id: 'MIDDLE_EAST',
  },
  {
    name: 'East Asia',
    id: 'EAST_ASIA',
  },
  {
    name: 'India',
    id: 'INDIA',
  },
  {
    name: 'Africa',
    id: 'AFRICA',
  },
  {
    name: 'Australia',
    id: 'AUSTRALIA',
  },
  {
    name: 'South America',
    id: 'SOUTH_AMERICA',
  },
  {
    name: 'North America',
    id: 'NORTH_AMERICA',
  },
  {
    name: 'New Zealand',
    id: 'NEW_ZEALAND',
  },
];

const regionTrue = true;

class EditProfile extends React.Component {
  state = { region: this.props.profile.region };

  onChange = () => event => {
    this.setState({ region: event.target.value });
  };

  render() {
    const {
      onClose,
      profile,
      onFieldUpdate,
      logoPreview,
      removeImage,
      avatarWillBeDeleted,
    } = this.props;
    return (
      <div>
        <CloseBtn onClick={onClose} />
        <div className="u-mrg-bot-30">
          <h2 className="t-secondary-30 u-mrg-bot-30 u-mrg-top-60">
            Edit profile
          </h2>
          {(function() {
            if (avatarWillBeDeleted)
              return (
                <div className="editProfileWrapper">
                  <AccountCircle className="editProfileAvatar" />
                  <input
                    name="profileImage"
                    type="file"
                    onChange={onFieldUpdate()}
                  />
                </div>
              );
            if (logoPreview) {
              return (
                <div className="editProfileWrapper">
                  <Logo image={logoPreview} />
                  <input
                    name="profileImage"
                    type="file"
                    onChange={onFieldUpdate()}
                  />
                </div>
              );
            }
            if (profile.imageId) {
              return (
                <div className="editProfileWrapper">
                  <Logo
                    image={`${API_ROOT}/asset/${profile.imageId}`}
                    trigerRemoveImage={removeImage}
                    showDeleteBtn={profile.imageId === null ? false : true}
                  />
                  <input
                    name="profileImage"
                    type="file"
                    onChange={onFieldUpdate()}
                  />
                </div>
              );
            }

            return (
              <div className="editProfileWrapper">
                <AccountCircle className="editProfileAvatar" />
                <input
                  name="profileImage"
                  type="file"
                  onChange={onFieldUpdate()}
                />
              </div>
            );
          })()}
          <b className="c-s_gray t-primary-16 u-mrg-top-20 element-block">
            Add/change your profile picture
          </b>
        </div>
        <Grid container spacing={8}>
          <Grid item md={6}>
            <FormControl fullWidth>
              <InputLabel
                htmlFor="firstName"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                First name
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                id="firstName"
                name="firstName"
                type="text"
                label="First name"
                value={profile.firstName}
                onChange={onFieldUpdate()}
              />
            </FormControl>
          </Grid>
          <Grid item md={6}>
            <FormControl fullWidth>
              <InputLabel
                htmlFor="lastName"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Last name
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                id="lastName"
                name="lastName"
                type="text"
                label="Last name"
                value={profile.lastName}
                onChange={onFieldUpdate()}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel
                htmlFor="region"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Region
              </InputLabel>
              <Select
                multiple
                id="regions"
                fullWidth
                name="regions"
                value={profile.regions}
                onChange={onFieldUpdate(regionTrue)}
              >
                {regions.map(r => {
                  return (
                    <MenuItem key={r.id} value={r.id}>
                      {r.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid item md={6}>
            <FormControl fullWidth>
              <InputLabel
                htmlFor="phone"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Phone
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                id="mobilePhone"
                name="mobilePhone"
                type="text"
                label="Phone"
                value={profile.mobilePhone}
                onChange={onFieldUpdate()}
              />
            </FormControl>
          </Grid>

          <Grid item md={6}>
            <FormControl fullWidth>
              <InputLabel
                htmlFor="mobile"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Mobile
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                id="mobileNumber"
                name="mobileNumber"
                type="text"
                label="Mobile"
                value={profile.mobileNumber}
                onChange={onFieldUpdate()}
              />
            </FormControl>
          </Grid>

          <Grid item md={12}>
            <FormControl fullWidth>
              <InputLabel
                htmlFor="address"
                classes={{
                  root: 'label--c-gray',
                }}
              >
                Address
              </InputLabel>
              <Input
                classes={{
                  underline: 'underline--c-light',
                }}
                id="address"
                name="address"
                type="text"
                label="address"
                value={profile.address}
                onChange={onFieldUpdate()}
              />
            </FormControl>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default EditProfile;
